import { IonCol, IonRow } from '@ionic/react'
import { TextLink, Titulo } from 'app-principal-componentes-visuales'
import React from 'react'
import './ReintentarPage.scss'

const ReintentarPage = ({ onClick }) => {

    return (
        <IonCol onClick={onClick} className='reintentar-page' >
            <IonRow className='testsin1'>
                <Titulo
                    
                    className="reintentar__title"
                    titulo={`Ocurrió un error. Presioná acá para reintentar`}
                    // id="titulo-asitencia-solicitar-socio"
                />
            </IonRow>
            <IonRow className='link-container' >
                <TextLink
                    id="asistencia-medica-text-link-terminos-condiciones"
                    texto="Reintentar"
                    className="footer-terminos-condiciones"
                />
            </IonRow>
        </IonCol>
    )
}

export default ReintentarPage